module.exports = __webpack_public_path__ + "fonts/Arimo-600-latin-ext23.70db804.woff2";